import { IconRectangle, IconLetterL, IconLetterT } from '@tabler/icons-react';
import { RoomShape } from '@/types/creator';

const shapes: RoomShape[] = [
	{
		id: '9246a188-ee93-455f-838b-e0b65b2f15c2',
		name: 'Prostokąt',
		vertices: [
			[-10, -10],
			[-10, 10],
			[10, 10],
			[10, -10],
		],
		Icon: IconRectangle,
	},
	{
		id: '5b9f4ba2-def0-4532-a7b0-9f1345898d95',
		name: 'Litera L',
		vertices: [
			[-10, -10],
			[-10, 10],
			[0, 10],
			[0, 0],
			[10, 0],
			[10, -10],
		],
		Icon: IconLetterL,
	},
	{
		id: '7c8a6f77-e019-42ea-9a57-e43fdd7cdcc2',
		name: 'Litera T',
		vertices: [
			[10, -10],
			[-10, -10],
			[-10, 0],
			[-4, 0],
			[-4, 10],
			[4, 10],
			[4, 0],
			[10, 0],
		],
		Icon: IconLetterT,
	},
];

export default shapes;
